import { Typography } from "@mui/material";
import React from "react";
import { theme } from "../../Assets/Theme/theme";

function Heading({ label, size }) {
  return (
    <Typography
      variant="h2"
      sx={{
        fontSize: { xs: "1.5rem", sm: "2.5rem", md: size ? size : "2.5rem" },
        fontWeight: "bold",
        marginBottom: 2,
        color: theme.colors.text,

      }}
    >
      {label}
    </Typography>
  );
}

export default Heading;
